import { render, staticRenderFns } from "./dateTips.vue?vue&type=template&id=74d56b2a&scoped=true"
import script from "./dateTips.vue?vue&type=script&lang=js"
export * from "./dateTips.vue?vue&type=script&lang=js"
import style0 from "./dateTips.vue?vue&type=style&index=0&id=74d56b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d56b2a",
  null
  
)

export default component.exports